define('home/views/ChannelTopicTabView',[
    'home/views/common/FetchableCollectionLayout',
    'home/templates/channelTopicTab',
], function (
    FetchableCollectionLayout,
    channelTopicTabTemplate
) {
    'use strict';

    /**
     * The view shown in the topic-filtered feed area of a channel page.
     * Includes a header that shows the topic on which the feed is filtered.
     */
    var ChannelTopicTabView = FetchableCollectionLayout.extend({
        template: channelTopicTabTemplate,
        templateHelpers: function () {
            return {
                topicName: this.filteredTopic.get('displayName'),
                channel: this.channel.toJSON(),
            };
        },

        initialize: function (options) {
            FetchableCollectionLayout.prototype.initialize.call(this, options);
            this.channel = options.channel;
            this.filteredTopic = options.filteredTopic;
            this.listenTo(this.filteredTopic, 'change:displayName', this.render);
        },
    });

    return ChannelTopicTabView;
});

